import './VisitDetailsListHeader.scss';

import * as React from 'react';

import { ProvidersList } from './ProvidersList';
import { Market } from '../../api/markets.types';

export interface VisitDetailsListHeaderProps {
  market?: Market;
  visitCount: number;
  breakCount: number;
  collapsed: boolean;
}

export const VisitDetailsListHeader = (props: VisitDetailsListHeaderProps) => {
  if (!props.market) {
    return null;
  }

  const visitCount = props.visitCount > 0 ? ` (${props.visitCount})` : '';
  const opacity = props.visitCount + props.breakCount > 0 ? 1 : 0.6;

  return (
    <div className="visit-details-list-container" style={{ opacity }}>
      <span className="title">{`${props.market.code} - ${props.market.name} ${visitCount}`}</span>
      <ProvidersList market={props.market.code} />
    </div>
  );
};
